unable to read source [project]/nextapp/node_modules/next/dist/compiled/@next/react-refresh-utils/internal/helpers.ts